<template>
<div>
    <!-- modal -->
    <b-modal id="lawMatterTradeFairEmployeeFormModal" ref="lawMatterTradeFairEmployeeFormModal" centered size="lg" no-close-on-backdrop :title=" $t('lawMatterTradeFairEmployee.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-row>
                <b-col class="col-lg-12">
                    <b-form>
                        <validation-provider v-slot="{ errors }" :name="$t('lawMatterTradeFairEmployee.employee')" :rules="{ excluded:0}">
                            <label for="law-matter-trade-fair-employee-input">{{ $t('lawMatterTradeFairEmployee.employee') }}</label>
                            <b-form-select size="sm" v-model="employeeSelect" :options="employeeOptions" value-field="id" name="law-matter-trade-fair-employee-input" text-field="fullName" :state="errors.length > 0 ? false:null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form>
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getLawMatterTradeFairEmployeeList: {
            type: Function
        }
    },
    data() {
        return {
            id: 0,
            lawMatterTradeFairId: 0,
            employeeSelect: 0,
            employeeOptions: [],
        }
    },
    methods: {
        showInfo(id, lawMatterTradeFairId) {
            this.$refs['lawMatterTradeFairEmployeeFormModal'].show()
            this.id = id
            this.lawMatterTradeFairId = lawMatterTradeFairId
            const data = { id: this.id }
            const controller = { name: 'LawMatterTradeFairEmployee' }
            const payload = { data: data, controller: controller }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.employeeSelect = response.data.lawMatterTradeFairEmployee.employeeId
                    this.employeeOptions = response.data.employeeList
                    this.employeeOptions.splice(0, 0, this.$nullSelected('fullName'))
                } else {
                    this.$bvModal.hide('lawMatterTradeFairEmployeeFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = { id: this.id, employeeId: this.employeeSelect, lawMatterTradeFairId: this.lawMatterTradeFairId }
            const controller = { name: 'LawMatterTradeFairEmployee' }
            const payload = { data: data, controller: controller }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('lawMatterTradeFairEmployeeFormModal')
                            this.getLawMatterTradeFairEmployeeList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
